import { useLocation, useNavigate } from "react-router-dom";
import { Car } from "@models/car";
import { editLastBread, getLastAvailableLink } from "@features/tickets/shared/utils/breadcrumbs";
import { CARS_BREADCRUMB, CARS_PATH, CARS_STRUCTURE_CRUMBS } from "./cars.constants";

export function useCarsNavigation() {
  const location = useLocation();
  const navigate = useNavigate();

  function buildBreadcrumb(state: unknown) {
    const base = [
      { name: CARS_BREADCRUMB.ledger },
      { name: CARS_BREADCRUMB.list, link: CARS_PATH },
    ];
    const stateRecord = state as { breadcrumbData?: { name: string; link?: string }[] } | null | undefined;
    return [...(editLastBread(stateRecord?.breadcrumbData, "/customers", state) ?? base)];
  }

  function rowChosen<T extends Car>(row: T) {
    if (!location.state?.breadcrumbData) {
      return;
    }

    navigate(getLastAvailableLink(location.state.breadcrumbData), {
      replace: true,
      state: {
        ...location.state,
        car: { ...row, id: undefined, car_id: row.id },
        document_account: {
          ...row.customer,
          id: undefined,
          account_id: row.customer?.id,
        },
        breadcrumbData: location.state.breadcrumbData.slice(0, -1),
      },
    });
  }

  function navigateToStructure(kind: "search" | "browse") {
    const currentState = { ...location.state };
    const breadcrumbData = buildBreadcrumb(currentState);
    const crumb = kind === "search" ? CARS_STRUCTURE_CRUMBS.search : CARS_STRUCTURE_CRUMBS.browse;

    navigate(`${CARS_PATH}/structure/${kind}`, {
      replace: true,
      state: {
        ...currentState,
        breadcrumbData: [...breadcrumbData, { name: crumb }],
      },
    });
  }

  return {
    rowChosen,
    editSearchStructure: () => navigateToStructure("search"),
    editBrowseStructure: () => navigateToStructure("browse"),
    selectRow: Boolean(location.state?.breadcrumbData),
  };
}
